export const DASH_PAYIN = () => {
  return (
      <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      opacity="0.4"
    >
      <path d="m22 2-8.2 8.2M13 6.17V11h4.83"></path>
    </g>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M11 2H9C4 2 2 4 2 9v6c0 5 2 7 7 7h6c5 0 7-2 7-7v-2"
    ></path>
  </svg>
  );
};
export const DASH_PAYOUT = () => {
  return (
      <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      opacity="0.4"
    >
      <path d="m13 11 8.2-8.2M22 6.8V2h-4.8"></path>
    </g>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M11 2H9C4 2 2 4 2 9v6c0 5 2 7 7 7h6c5 0 7-2 7-7v-2"
    ></path>
  </svg>
  );
};
export const DASH_TOTAL_SETTLE = () => {
  return (
      <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      fill="#64800F"
      d="M14 25.667c6.444 0 11.667-5.224 11.667-11.667S20.443 2.333 14 2.333 2.334 7.557 2.334 14 7.557 25.667 14 25.667"
      opacity="0.3"
    ></path>
    <path
      fill="#64800F"
      d="M12.647 17.885a1.17 1.17 0 0 1-.829-.338L9.1 14.828a1.167 1.167 0 1 1 1.645-1.656l1.902 1.901 4.666-4.666a1.167 1.167 0 1 1 1.645 1.645L13.463 17.5a1.17 1.17 0 0 1-.816.385"
    ></path>
  </svg>
  );
};
export const DASH_WITHDRAW = () => {
  return (
      <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="27"
    fill="none"
    viewBox="0 0 24 27"
  >
    <path
      fill="#1B8636"
      d="M22 14.063V18c0 1.79-.632 3.507-1.757 4.773S17.59 24.75 16 24.75H8c-1.591 0-3.117-.711-4.243-1.977C2.632 21.507 2 19.79 2 18V9c0-1.79.632-3.507 1.757-4.773S6.41 2.25 8 2.25h3.5c.73 0 1.429.326 1.944.906.516.58.806 1.367.806 2.188v1.968c.003.97.346 1.898.955 2.583s1.434 1.07 2.295 1.074h1.75c.361 0 .719.08 1.052.235.334.156.637.384.893.67.255.288.457.63.596 1.005s.209.777.209 1.184"
      opacity="0.3"
    ></path>
    <path
      fill="#1B8636"
      d="M15.75 5.344a5.15 5.15 0 0 0-.72-2.666 5.9 5.9 0 0 1 2.14 1.552l3.07 3.454a6.7 6.7 0 0 1 1.37 2.385 3.9 3.9 0 0 0-2.36-.788H17.5c-.464 0-.909-.207-1.237-.576a2.1 2.1 0 0 1-.513-1.392zM16 19.125H8a.95.95 0 0 1-.707-.33A1.2 1.2 0 0 1 7 18a1.2 1.2 0 0 1 .293-.796.95.95 0 0 1 .707-.329h8c.265 0 .52.119.707.33A1.2 1.2 0 0 1 17 18a1.2 1.2 0 0 1-.293.796.95.95 0 0 1-.707.329M13 14.625H7.95a.95.95 0 0 1-.707-.33 1.2 1.2 0 0 1-.293-.795 1.2 1.2 0 0 1 .293-.796.95.95 0 0 1 .707-.329h5.07c.265 0 .52.118.707.33a1.2 1.2 0 0 1 .293.795 1.2 1.2 0 0 1-.293.796.95.95 0 0 1-.707.329z"
    ></path>
  </svg>
  );
};
export const DASH_INIT = () => {
  return (
      <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="27"
    fill="none"
    viewBox="0 0 28 27"
  >
    <path
      fill="#BE759A"
      d="M14 24.75c5.477 0 9.917-4.281 9.917-9.562 0-5.282-4.44-9.563-9.917-9.563s-9.916 4.281-9.916 9.563c0 5.28 4.44 9.562 9.916 9.562"
      opacity="0.5"
    ></path>
    <path
      fill="#BE759A"
      d="M14 15.75c-.31 0-.606-.118-.825-.33a1.1 1.1 0 0 1-.341-.795V11.25c0-.298.122-.585.341-.796.219-.21.516-.329.825-.329.31 0 .606.118.825.33.219.21.342.497.342.795v3.375c0 .298-.123.585-.342.796-.219.21-.515.329-.825.329M17.5 4.5h-7c-.31 0-.606-.119-.825-.33a1.1 1.1 0 0 1-.341-.795c0-.298.122-.585.341-.795s.516-.33.825-.33h7c.31 0 .606.119.825.33.219.21.342.497.342.795s-.123.585-.342.795-.515.33-.825.33"
    ></path>
  </svg>
  );
};
export const DASH_DEPOSIT = () => {
  return (
       <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#738ABC"
      d="M16 2H8a6 6 0 0 0-6 6v8a6 6 0 0 0 6 6h8a6 6 0 0 0 6-6V8a6 6 0 0 0-6-6"
      opacity="0.3"
    ></path>
    <path
      fill="#738ABC"
      d="m15.7 13.71-3 3a1 1 0 0 1-1.41 0l-3-3a1 1 0 1 1 1.41-1.42l1.3 1.3V8a1 1 0 0 1 2 0v5.59l1.29-1.3a1 1 0 1 1 1.41 1.42"
    ></path>
  </svg>
  );
};
